// extracted by mini-css-extract-plugin
export default {"header":"headerBack_header__m6SlO","backButton":"headerBack_backButton__ZdTEI","title":"headerBack_title__zSiEt","subtitle":"headerBack_subtitle__3iPOZ"};